import React, { useEffect, useState } from "react";
import { Box, Container, Paper, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "../../../store";
import { getTile, selectTile } from "../../../slices/tile";
import TileForm from "./TileForm";
import theme from "../../../theme";
import Tile from "../../../types/tile";

interface Props {
  id?: number;
  tileType: "dashboard" | "tile";
}

const AddEditTile: React.FC<Props> = (props) => {
  const { id, tileType } = props;

  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  const dispatch = useDispatch();

  const { selectedDashboard, homeDashboard } = useSelector(
    (store) => store.dashboard,
  );
  const { tile } = useSelector((store) => store.tiles);

  const [tileForm, setTileForm] = useState<Tile>(tile);

  useEffect(() => {
    if (!id) {
      dispatch(selectTile(undefined));
    } else {
      dispatch(
        getTile({
          id: +id!,
          includeData: false,
          fullTile: true,
        }),
      ).then((result) => {
        if (result && result.payload) setTileForm(result.payload);
      });
    }
  }, [dispatch, id, tile]);

  useEffect(() => {
    return () => {
      dispatch(selectTile(undefined));
    };
  }, [dispatch]);

  return (
    <Container sx={{ marginBottom: 8 }}>
      <Paper
        sx={{
          paddingY: 3,
          paddingX: xs ? 2 : 7,
          marginBottom: 5,
        }}
      >
        <Box display="flex" flexDirection="row" justifyContent="space-around">
          <Box display="flex" flexDirection="column" width="100%">
            <TileForm
              tile={tileForm}
              dashboardId={
                id
                  ? tile?.dashboard?.id!
                  : (selectedDashboard || homeDashboard?.id)!
              }
              tileType={tileType}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default AddEditTile;
